import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import ReactPaginate from 'react-paginate'
import Notifications from 'react-notification-system-redux'

import { getListItemsCountMessage, getPrerequisitesArray } from '../../../common/helpers'

import { prepareTableActionCreators } from '../../../common/table/actionCreators'
import { TableFilterInputField, TableFilterSelectField, TableFilterBooleanField } from '../../../common/table/components'
import { getTotalNumberOfPages } from '../../../common/table/helpers'
import { TableModelColumn, TableModelColumnFilteringType } from '../../../common/table/model'
import { createTableDataSelector, createTableModelSelector } from '../../../common/table/selectors'

import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'

import * as vehiclesActionCreators from '../actionCreators'
import { getVehicles } from '../selectors'
import { createGetUserByIDSelector } from '../../users/selectors'

import VehiclesHistoryVehiclesRow from './VehiclesHistoryVehiclesRow'

const tableIdentifier = 'vehicles_list'
const clientSideItemsPerPage = undefined

const componentIdentifier = 'vehicles_list'
const prerequisites = ['dispatchers']

const columns = {
    fb_id: new TableModelColumn({}),
    registration: new TableModelColumn({}),
}

class VehiclesHistoryVehicles extends Component {
    componentDidMount() {
        this.props.actions.fetchVehicles()
        this.props.actions.fetchPrerequisites()
    }

    render() {
        const filters = this.props.tableModel.get('filters')

        return (
            <React.Fragment>
                <div className="table-container">
                    <table className="table table-striped table-hover table-fixed-header">
                        <thead>
                            <tr>
                                <th className="w-140">
                                    <FormattedMessage id="fields.vehicle" />
                                </th>
                                <th className="w-max wm-200">
                                    <FormattedMessage id="fields.vin" />
                                </th>
                                <th className="w-120">
                                    <FormattedMessage id="fields.dispatcher" />
                                </th>
                                <th className="w-80 text-center">
                                    <FormattedMessage id="fields.active" />
                                </th>
                                <th className="w-40" />
                            </tr>
                            <tr className="filters">
                                <th className="w-140">
                                    <TableFilterInputField
                                        identifier="registration"
                                        type={TableModelColumnFilteringType.string}
                                        filters={filters}
                                        onChange={this.props.table.changeFilter}
                                    />
                                </th>
                                <th className="w-max wm-200">
                                    <TableFilterInputField
                                        identifier="vin"
                                        type={TableModelColumnFilteringType.string}
                                        filters={filters}
                                        onChange={this.props.table.changeFilter}
                                    />
                                </th>
                                <th className="w-120">
                                    <TableFilterSelectField
                                        identifier="dispatcher_id"
                                        type={TableModelColumnFilteringType.equal}
                                        filters={filters}
                                        onChange={this.props.table.changeFilter}
                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('dispatchers'))}
                                    />
                                </th>
                                <th className="w-80">
                                    <TableFilterBooleanField
                                        identifier="is_active"
                                        type={TableModelColumnFilteringType.equal}
                                        filters={filters}
                                        onChange={this.props.table.changeFilter}
                                    />
                                </th>
                                <th className="w-40" />
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.vehicles.data.valueSeq().map(vehicle => (
                                <VehiclesHistoryVehiclesRow
                                    key={`row-${vehicle.id}`}
                                    vehicle={vehicle}
                                    dispatcher={this.props.createGetUserByIDSelector(vehicle.dispatcher_id)}
                                    selectedVehicle={this.props.selectedVehicle}
                                    onVehicleSelect={this.props.onVehicleSelect}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pull-left m-l-xxs m-t-md">
                    <FormattedMessage id="pagination.totalRecords" />:{' '}
                    {getListItemsCountMessage(
                        clientSideItemsPerPage,
                        this.props.vehicles.count,
                        this.props.tableModel.getIn(['pagination', 'totalCount'])
                    )}
                </div>

                <ReactPaginate
                    containerClassName="pagination"
                    breakLabel={<span className="disabled">...</span>}
                    activeClassName="active"
                    pageCount={getTotalNumberOfPages(this.props.tableModel, this.props.vehicles.count, clientSideItemsPerPage)}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={2}
                    forcePage={this.props.tableModel.getIn(['pagination', 'current'])}
                    onPageChange={this.props.table.changePage}
                    ppreviousLabel={this.props.intl.formatMessage({ id: 'pagination.previous' })}
                    nextLabel={this.props.intl.formatMessage({ id: 'pagination.next' })}
                />
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        vehicles: createTableDataSelector({
            tableIdentifier,
            columns,
            dataSelector: getVehicles,
            clientSideItemsPerPage,
        })(state),
        tableModel: createTableModelSelector(tableIdentifier)(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
        createGetUserByIDSelector: id => createGetUserByIDSelector(id)(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...vehiclesActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        table: bindActionCreators(prepareTableActionCreators(tableIdentifier, stateProps.tableModel), dispatchProps.dispatch),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(VehiclesHistoryVehicles)
)
